export enum EFormElementType {
    Input = "input",
    TextArea = "textarea",
    Captcha = "captcha",
    Submit = "submit",
    Checkbox = "checbox",
    Select = "select",
    RadioButton = "radio"
}
